import PropTypes from 'prop-types';
import { Card, CardHeader, CardContent, Typography, Grid, Chip, Box } from '@material-ui/core';
import Alert from '@mui/material/Alert';
import { elapsedTimeToStr, getElapsedSeconds } from '../../../utils/formatTime';
import { RunningStateChip } from '.';

function formatElapsedTime(time) {
  const elapsed = getElapsedSeconds(time);
  return elapsedTimeToStr(elapsed);
}

function formatCountdown(seconds) {
  if (seconds === null || seconds === undefined) {
    return 'Disabled';
  }
  if (seconds < 0) {
    return 'Past due';
  }
  return elapsedTimeToStr(seconds).trim();
}

RackLifecycleInfo.propTypes = {
  rackDetails: PropTypes.object
};

export default function RackLifecycleInfo({ rackDetails }) {
  const inactivity = rackDetails.lifecycle?.inactivity_policy;

  return (
    <Card data-testid="rack-lifecycle-info" sx={{ flex: 1 }}>
      <CardHeader title="Lifecycle" />
      <CardContent sx={{ marginBottom: 1 }}>
        <Grid container spacing={3}>
          <Grid item xs={12} lg={6}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Typography variant="overline" sx={{ flexShrink: 0 }}>
                Running
              </Typography>
              <RunningStateChip runningState={rackDetails.running.state} />
            </Box>
          </Grid>
          <Grid item xs={12} lg={6}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Typography variant="overline" sx={{ flexShrink: 0 }}>
                Last Accessed
              </Typography>
              <Chip
                label={formatElapsedTime(rackDetails.last_accessed)}
                size="small"
                variant="outlined"
                color="primary"
              />
            </Box>
          </Grid>
          {inactivity?.time_till_shutdown > 0 ? (
            <Grid item xs={12} lg={6}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Typography variant="overline" sx={{ flexShrink: 0 }}>
                  Auto Stop In
                </Typography>
                <Chip
                  label={formatCountdown(inactivity?.time_till_shutdown)}
                  size="small"
                  variant="outlined"
                  color="primary"
                />
              </Box>
            </Grid>
          ) : (
            <Grid item xs={12} lg={6}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Typography variant="overline" sx={{ flexShrink: 0 }}>
                  Auto Delete In
                </Typography>
                <Chip
                  label={formatCountdown(inactivity?.time_till_delete)}
                  size="small"
                  variant="outlined"
                  color="primary"
                />
              </Box>
            </Grid>
          )}
        </Grid>
        <Alert severity="info" sx={{ mt: 2 }}>
          To modify lifecycle policies, please contact the Virtual Rack team.
        </Alert>
      </CardContent>
    </Card>
  );
}
